import type { ReactNode } from "react";

export const launchableContentTabsListClassName =
  "-mx-5 -mt-4 mb-7 w-[calc(100%+2.5rem)] flex-wrap rounded-t-[7px] border-zinc-700 bg-secondaryBg px-5 pt-4 sm:-mx-6 sm:-mt-5 sm:w-[calc(100%+3rem)] sm:px-6 sm:pt-5";

export interface LaunchableContentTab {
  value: string;
  label: string;
  content: ReactNode;
}

export interface LaunchableContentTabProps {
  activeTab?: string;
  onActiveTabChange?: (value: string) => void;
  leadingTabs?: LaunchableContentTab[];
  trailingTabs?: LaunchableContentTab[];
}
